import api from "../api"

export class InfoService {
    static async getInfo(): Promise<any> {
        const res = await api.get("/info")
        if (res.status !== 200) throw new Error("Erreur lors de la récupération des informations")
        return res.data as any
    }
}
